import config from '@/config.js';

const DEFAULT_SETTINGS = {
    'app_language': 'english',
    'privacy_profile_picture_visibility': 'anyone',
    'privacy_last_seen_visibility': 'anyone',
    'privacy_status_visibility': 'anyone',
    'notifications_web': 'disabled',
    'notifications_sound': 'disabled',
};

export default {
    namespaced: true,

    state: () => ({
        settings: {},
        languages: [],
        loaded: false,
    }),

    getters: {
        settingsLoaded: state => state.loaded,
        settings: (state) => state.settings,
        languages: (state) => state.languages,
    },

    mutations: {
        setSettings(state, list) {
            state.settings = {};

            Object.keys(DEFAULT_SETTINGS).forEach(key => {
                state.settings[key] = DEFAULT_SETTINGS[key];
            });

            list.forEach(item => {
                state.settings[item.key] = item.value;
            });

            state.settingsLoaded = true;
        },

        setLanguages(state, list) {
            state.languages = list;
        },

        async overrideSettings(state, data) {
            Object.keys(data).forEach(key => {
                state.settings[key] = data[key];
            });
        },
    },

    actions: {
        async get({commit}) {
            // Get languages
            let r = await window.http.get(`${config.API_URL}/languages`);
            if (r.success) {
                commit('setLanguages', r.data);
            }

            r = await window.http.get(`${config.API_URL}/settings`);
            if (r.success) {
                commit('setSettings', r.data);
            }

            return r;
        },

        async store({commit, dispatch}, settings) {
            const r = await window.http.post(`${config.API_URL}/settings`, {settings});

            if (r.success) {
                await commit('overrideSettings', settings);
                await dispatch('features/load', {}, {root: true});
            }

            return r;
        },
    }
};
